import { ReactNode } from "react";
export interface INav {
  children?: ReactNode;
  className: string;
}
function Nav({ children, className }: INav) {
  return <div className={className}>{children}</div>;
}

export default Nav;
